import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { RenameDrawingBundleParams } from "./drawingMesh.types";

/**
 * 묶음(zip 업로드 단위)의 표시명 변경 — `PATCH /v1/projects/{project_id}/drawing-meshes/bundles`.
 *
 * 도면 rename(`renameDrawingMesh`)과 **같은 봉투·같은 계약**이고 갈리는 것은 경로와 대상뿐이다: 대상 지정자는 묶음
 * identity(`bundles[].name`)이지 표시명이 아니다. `display_name: null` 은 reset 이라 그 뒤 조회가 `name` 으로
 * fallback 한다. 값 규약(1~100자 trim · 줄바꿈·제어문자 거부 · NFD 저장)과 거부(비멤버 404 · 멤버 비-writer 403 ·
 * 없는 묶음 404 — 도면 이름으로 지목해도 404 · 같은 프로젝트의 다른 묶음이 쓰는 표시명 409)는 서버가 판정하므로
 * 여기에는 사전 검사가 없다. 도면 표시명과는 서로를 막지 않는다.
 *
 * main-api 는 "Bearer <token>" 형식이라 Amplify gateway 가 아니라 raw fetch + `getIdToken()` 이다.
 * rename 은 구성원을 움직이지 않는다 — 응답의 `name` 은 보낸 identity 그대로이고, 구성원 도면의 이름·`bundle_name`
 * 은 바뀌지 않는다.
 */
export async function renameDrawingBundle(
  projectId: number,
  params: RenameDrawingBundleParams
): Promise<{ name: string; display_name: string }> {
  const token = await getIdToken();

  const res = await fetch(
    `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/bundles`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(params),
    }
  );

  if (!res.ok) {
    throw Object.assign(
      new Error(`묶음 표시명 변경 실패 (${res.status})`),
      { status: res.status }
    );
  }

  const body = await res.json();
  // 응답 봉투 { status, data } 언랩 — 도면 rename 과 같은 규약
  return body.data ?? body;
}
